
import manualButton from '../manual-button';
import doubleDate from './double-date';
import dateFormat from 'vux/src/tools/date/format.js'

export default {
name: "order-p",
components: {
manualButton,
doubleDate
},
data() {
return {
orderStateList: [
{name:'全部',code:'',selected:true},
{name:'待确认',code:'1'},
{name:'已确认',code:'2'},
{name:'已作废',code:'6'},
{name:'已退回',code:'7'}
],
supOrderStateList:[
{name:'全部',code:'',selected:true},
{name:'待确认',code:'1'},
{name:'已确认',code:'2'},
{name:'已入库未对账',code:'3'}
],
orderTypeList:[],
checkedDtoList:[],
purorgList:[],
plantList:[],
startTime:'',
endTime:'',
dateTitle:'',
isManualShow:true,
}
},
methods: {
reload(){
this.checkedDtoList=[];
this.startTime='';
this.endTime='';
this.$refs.manulaDate.resetTime();
this.show=false;
this.$nextTick(()=>{
this.show=true;
})
},
closeReset(){
this.isManualShow=true;
this.$refs.manulaDate.show=false;
},
checkerChange(value,name,chinese,option="IN"){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
},
chooseDate(e){
this.isManualShow=false;
this.$refs.manulaDate.dateTitle=e;
this.$refs.manulaDate.show=true;
},
dateChoose(e){
if(e.startTime){
this.startTime=dateFormat( new Date(e.startTime).getTime(),"YYYY-MM-DD")
this.endTime=dateFormat( new Date(e.endTime).getTime(),"YYYY-MM-DD")
this.checkerChange([e.startTime,e.endTime],'deliveryDate','date','BTD')
}else {
this.startTime='';
this.endTime='';
this.checkedDtoList=this.checkedDtoList.filter(val=>val.ch!='date')
}
this.isManualShow=true;
},

getOrderTypeList(){
this.$loadingShow();
this.$get('api/order-type/all').then((data) => {
this.$loadingHide()
data.splice(
data.indexOf(data.find(function(element){ return element.name == "普通订单"  })), 1);
data.splice(
data.indexOf(data.find(function(element){ return element.name == "统购订单"  })), 1);
this.orderTypeList = data.map(item => {
item.code = item.id;
return item;
});
this.orderTypeList.unshift({name:'全部',code:''});
}).catch(()=>{
this.$loadingHide()
})
},

getPurorgList() {
this.$loadingShow();
this.$get('api/purorg').then((data) => {
data.forEach(val=>{
val.name=val.purorgName;
val.code=val.purorgCode
})
this.purorgList = data.filter(item =>{
return item.enabled;
});;
this.purorgList.unshift({code: '', name: '全部'})
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},

getPlantList() {
this.$loadingShow();
this.$get('api/plant').then((data) => {
data.forEach(val=>{
val.name=val.plantName;
val.code=val.plantCode
})
this.plantList = data.filter(item =>{
return item.enabled;
});;
this.plantList.unshift({code: '', name: '全部'})
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
},

created() {
this.getPurorgList();
this.getPlantList();
this.getOrderTypeList();
}


}



// WEBPACK FOOTER //
// ./src/components/manual-search/order-p.vue